import type { FaireProductEntity } from "../../entity_types/product";

export const p_upvvxf5eww: FaireProductEntity = {
  token: "p_upvvxf5eww",
  type: "product",
  name: "Heritage Knit 100% Organic Cotton Swaddle Baby Blanket",
  brandToken: "b_cthcrk96df",
  brandName: "Bleu La La",
  imageUrl:
    "https://cdn.faire.com/fastly/03efe5f69720a91db2761ac09fcb9fcafb0c99fc5e1ecf0a59efeb9c72210913.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f66d9b6321130c16934f30bddbd4bca51d30541a6011980ae242ee10db4e9ab.jpeg",
    "https://cdn.faire.com/fastly/920d18362ae9ee237192583c2b05af089e683b2e519f565da8e04d4a053e2a6e.jpeg",
    "https://cdn.faire.com/fastly/52b9b62b9d57914ce075911a86065809be47d6895d3910ed0d37e864ba9b9254.jpeg",
    "https://cdn.faire.com/fastly/2b1e20f30b57c30312df7e0672d002724b637deef3801e9c12c3fde6b01920c1.jpeg",
    "https://cdn.faire.com/fastly/50ea20a76ad5fd44871423baf6fae70094a73b310ad1d3a4ee9f43e99b4e9676.jpeg",
    "https://cdn.faire.com/fastly/94ab0718180c5c78f25c4468d4cc6d271491c50b11190f328c792f501f734dcf.jpeg",
    "https://cdn.faire.com/fastly/1686634ce59a62b7b3f50020a47625e2903ab9dc6a2fdaf32edf9268082badfc.jpeg",
    "https://cdn.faire.com/fastly/c90539e44ad1d33590527f0d16712a106dbe32d090dac3d1478bb2ed7c11f2fa.jpeg",
    "https://cdn.faire.com/fastly/23fdfa03980b39dfacef656a3f2235b8210eb388e68e107889becb60766ac418.jpeg",
    "https://cdn.faire.com/fastly/500ee5ff6edc2d4493764972625943a712c76b65af3b3437826f84a23796ec38.jpeg",
    "https://cdn.faire.com/fastly/f6d3c5a27b9cff599e68022e7daa770212603b228f56a24285af19d348de7413.jpeg",
    "https://cdn.faire.com/fastly/b1b4e39b9dc3c0e92ef2dfbb74cd0f36ebbf16d9dd172db424ea97c5455d21c2.jpeg",
    "https://cdn.faire.com/fastly/352a85bdbf5a4f2b8cb53a174ef6541af4135ba7dd643be3005c992113ca05a1.jpeg",
    "https://cdn.faire.com/fastly/e4bfdb54a43b56f7891d132ba52b14b55be672ce1ad7fb5bed440736e8a4b881.jpeg",
    "https://cdn.faire.com/fastly/51e6265222140efcaa3d8ca3afeaa811fd6d86cf8f0aaa2817eac542648df452.jpeg",
    "https://cdn.faire.com/fastly/a76f9679e8ecf205eefd4cc6bd0207ccfdc52816355a11d4ce9978a8230c8549.jpeg",
    "https://cdn.faire.com/fastly/f61b7db6cf55b210f40ac8fda727f6f7c985ed5dc181236927df6bd2cdf13bd1.jpeg",
    "https://cdn.faire.com/fastly/4d81ddb13c1b7e72dbbe7252d0fa637a21e9bb747634d808ad18426103530ee9.jpeg",
    "https://cdn.faire.com/fastly/0ed6eba3c0895af233f92e46a4305feaa3df5c87f927415e1b0d609249223ffd.jpeg",
    "https://cdn.faire.com/fastly/027ba86c18b50c4a46540e7b95701b70b312dc5b762d908e3d2ebe02221a6948.jpeg",
    "https://cdn.faire.com/fastly/a1007a26e4b0cede2dafffa1f938bce7653ad6f7a9e60d90f04271fb6a8cdd83.jpeg",
    "https://cdn.faire.com/fastly/7cbac40a6de479bb935a83e9fcdeba7e0f18a9ae236a07631d139e8330b6554c.jpeg",
    "https://cdn.faire.com/fastly/7b08759eb95b2939642c11b07833fe3a9ea27034cea8ca736fed8d6d8168c8c0.jpeg",
    "https://cdn.faire.com/fastly/93816851bacd1fbcdea056a540c4f4b547ca5aae30e10bd622d75769ce1c8d4c.jpeg",
    "https://cdn.faire.com/fastly/61ca0e731da12e6b0c3e8193a3bf48b274e0264be0b082de046811e3a8f1cc05.jpeg",
    "https://cdn.faire.com/fastly/2d9c8778dd7fd5761127e5c156c0944fb98273b8ac7d8bc2e7f4149a866489c0.jpeg",
    "https://cdn.faire.com/fastly/1b3babb2814ad9646e51dbe4d7c9ee61ee5e26bf49d008f8cfa9c29bdfb4f3c5.jpeg",
    "https://cdn.faire.com/fastly/40ab00a523adea6af51915c27636bb9aba1d7848f56472b2419677a196130aef.jpeg",
    "https://cdn.faire.com/fastly/59fe171013d28add8840521a7b9cfafa01a6a71eb416a79f5f02dd94ab398ef8.jpeg",
    "https://cdn.faire.com/fastly/5ff14090ed24fbbc7464cc4893d06227ccf4190e8726782bd38c052ed52233c2.jpeg",
    "https://cdn.faire.com/fastly/dc5f570f8f349e3f5bb6d8b2336c8bc53c664741accc00914370de6e31155fd0.jpeg",
    "https://cdn.faire.com/fastly/90a211adc1138c94453d4e23281a8f886dd77880a7f116b306f6f6b5f011357e.jpeg",
  ],
  priceDollars: 18,
  description:
    'Lightweight and Breathable: \nCrafted with 100% luxurious organic fine loomed cotton. Tenderly soft, breathable, and gentle enough for newborn babies delicate skin. Warm, but lightweight, perfect for keeping baby baby safe and secure.\n\nVersatile and Durable: \nMeasuring 36" x 32" perfect size for any stroller and car seat. Great as as a wrap, swaddle or cuddle blanket. Cozy during the winter yet comfortable in warm weather.  \n\n* Machine washable, tumble dry on low. \n* Packaged in textured ribbon. Tagged, polly bagged, and barcoded.  \n* Your purchase matters. 10% of profits donated to infertility charities.',
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:42.143Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
